import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconArrowDown = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='m7 13 5 5 5-5' />
      <path d='M12 18V4' />
    </g>
  </SDIcon>
)

export default IconArrowDown
